import * as Yup from 'yup'
import { t } from '../../i18n'

const scope = 'locations'

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  currency_id: Yup.number().label(t('currency', { scope })).required(t('required', { scope })),
  temperature_scale: Yup.string()
    .label(t('temperature_scale', { scope }))
    .required(t('required', { scope })),
  weight_scale: Yup.string()
    .label(t('weight_scale', { scope }))
    .required(t('required', { scope })),
  timezone: Yup.string()
    .label(t('timezone', { scope }))
    .required(t('required', { scope })),
  webhook_url: Yup.string().label(t('webhook_url', { scope })).url(),
  nonstop_working_hours: Yup.boolean().label(t('nonstop_working_hours', { scope })),
  working_start_hour: Yup.number()
    .label(t('working_start_hour', { scope }))
    .integer()
    .nullable(),
  working_end_hour: Yup.number()
    .label(t('working_end_hour', { scope }))
    .integer()
    .nullable(),
  sensor_report_emails: Yup.array()
    .of(Yup.string().email('Invalid email format'))
    .label('Sensor Report Emails'),
  critical_issue_phone_numbers: Yup.array()
    .of(Yup.string().matches(/^\+?[1-9]\d{1,14}$/, 'Invalid phone number format'))
    .label('Critical Issue Receiver Phone Numbers')
})
